"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var styles_1 = require("@mui/material/styles");
var Button = __importStar(require("./A_Button"));
var ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
// The intent is to mimic the styling of the ToggleButtonGroup example:
// https://mui.com/material-ui/react-toggle-button/#customization
var StyledButtonGroup = (0, styles_1.styled)(ButtonGroup_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: 8,
        border: 0,
        backgroundColor: theme.palette.secondary.contrastText,
        '& .MuiButtonGroup-grouped': {
            padding: 11,
            border: 0,
            backgroundColor: theme.palette.secondary.contrastText,
            color: theme.palette.secondary.main,
            '&:not(:last-of-type) ': {
                borderRight: 0,
            },
            '&:not(:first-of-type) ': {
                borderLeft: 0,
            },
            '&:hover': {
                backgroundColor: theme.palette.secondary.contrastText,
                '& .MuiSvgIcon-root': {
                    fill: theme.palette.primary.main,
                },
            },
        },
    });
});
/** Represents a group of buttons, intended as a context menu after furniture is selected */
var Component = function (props) {
    var handleClick = function (event, value) {
        if (value !== null) {
            props.buttons[value].onSelect();
        }
    };
    return (Preact.h(StyledButtonGroup, { variant: "contained", "aria-label": props['aria-label'], size: props.size, color: "secondary" }, Object.entries(props.buttons).map(function (_a) {
        var value = _a[0], _b = _a[1], Icon = _b.Icon, onSelect = _b.onSelect, ariaLabel = _b["aria-label"];
        return (Preact.h(Button.Component, { onClick: onSelect, "aria-label": ariaLabel },
            Preact.h(Icon, null)));
    })));
};
exports.Component = Component;
